export interface RuntimeConfig {
  apiUrl?: string;
  authUrl?: string;
  scheduleUrl?: string;
  restaurantUrl?: string;
  fuelUrl?: string;
  grafanaUrl?: string;
  keycloakUrl?: string;
  keycloakClientId?: string;
  reportingAppUrl?: string;
  spreadsheetOpenUrl?: string;
  spreadsheetSaveUrl?: string;
}

declare global {
  interface Window {
    __JRETAIL_CONFIG__?: RuntimeConfig;
  }
}

const runtimeConfig =
  typeof window === 'undefined' ? {} : (window.__JRETAIL_CONFIG__ ?? {});

export function runtimeConfigValue(
  key: keyof RuntimeConfig,
  fallback: string
): string {
  const value = runtimeConfig[key];
  return typeof value === 'string' && value.trim() ? value.trim() : fallback;
}
